import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. Todo en PDF.'
  }, {
    q: '¿Sirve para todos los niveles de alumnos?',
    a: 'Sí, desde nivel inicial (cero) hasta avanzado.'
  }, {
    q: '¿Es editable?',
    a: 'El material viene en PDF listo para imprimir o leer en cualquier dispositivo.'
  }, {
    q: '¿Los 4 bonos están incluidos en ambas ofertas?',
    a: 'Sí, tanto el Kit Básico como el Pack Pro incluyen los 4 bonos.'
  }, {
    q: '¿Puedo comprar el Kit básico y después actualizar?',
    a: 'Sí, pero recomendamos el Pack Pro desde el inicio.'
  }, {
    q: '¿Funciona para clases al aire libre y en gimnasio?',
    a: 'Totalmente. Se adapta a ambos formatos y espacios.'
  }, {
    q: '¿Qué materiales necesito?',
    a: 'Incluye opciones con peso corporal y materiales básicos (kettlebells, mancuernas, conos, sogas).'
  }, {
    q: '¿Está organizado por nivel?',
    a: 'Sí, todo tiene progresión lógica: principiante, intermedio y avanzado.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, 7 días de garantía de satisfacción total.'
  }, {
    q: '¿Qué diferencia tiene con rutinas de internet?',
    a: 'No son ejercicios sueltos. Es un sistema pedagógico completo y progresivo.'
  }];
  return <section className="bg-white py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-33">
      <div className="max-w-2xl mx-auto" data-id="element-34">
        <h2 className="text-xl md:text-2xl font-black text-[#0B1F3A] text-center mb-3 uppercase tracking-tight" data-id="element-35">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-1.5" data-id="element-36">
          {faqs.map((faq, i) => <div key={i} className="bg-[#F5F5F5] border border-gray-200 rounded-lg overflow-hidden" data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-2.5 text-left hover:bg-gray-200 transition-colors" data-id="element-38">
                <span className="font-black text-[#0B1F3A] text-xs md:text-sm pr-3" data-id="element-39">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} data-id="element-40">
                  <ChevronDown className="w-4 h-4 text-[#FF6B00] flex-shrink-0" strokeWidth={3} data-id="element-41" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-42">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-43">
                    <div className="px-2.5 pb-2.5 text-gray-700 font-bold text-xs border-t border-gray-200 pt-2 bg-white" data-id="element-44">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}